const getters = {
    /**
     *
     * @param {Object} state - taxonomies module state
     * @returns {Object[]} Array of all shared taxonomies
     */
    getSharedTaxonomies: state => () => Object.values(state.shared).filter(item => item.status === 'active'),

    /**
     *
     * @param {Object} state -taxonomies module state
     * @returns {Object[]} Array regrouping all segments for all shared taxonomies
     */
    getAllSegments: state => () => {
        let allSegments = [];
        const shared = Object.values(state.shared)
        for (let i = 0; i < shared.length; i++) {
            allSegments = [...allSegments, ...Object.values(shared[i])]
        }
        return allSegments
    },

    /**
     * Find segment by his jsonKey.name
     *
     * @param {Sring} jsonKeyName
     * @returns {Object|Undefined} segment with same jsonKeyName or undefined if none exists
     */
    getSegmentByJsonKeyName: (_, getters) => jsonKeyName => {
        return getters.getAllSegments().find(segment => segment.jsonKey.name === jsonKeyName)
    },

    /**
     * Check that the get of taxonomies and segments do not load
     * and that we have one segment per taxonomy
     *
     * @param {Object} state - vuex state for taxonomies module
     * @param {Object} getters - vuex getter for taxonomies module
     * @param {Object[]} getters.getSharedTaxonomies
     * @returns {Boolean}
     */
    isReadyForCriteriaList: (state, { getSharedTaxonomies }) => () => {
        return !state.isLoading && getSharedTaxonomies().every(taxonomie => taxonomie.segmentsAlreadyFetched)
    }
}

export default getters
